module.exports = __webpack_public_path__ + "img/8178580.png";